var _style, _path, _path2, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4G(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x34_G",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    style: {
      enableBackground: "new 0 0 43 43",
      display: "none"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.1299,31.0355v-3.3457h-7.042v-2.6475l5.8931-11.437h4.0703v11.5874h2.0728v2.4824h-2.0728v3.3604H14.1299z  M9.5352,25.1927h4.5947v-8.5908h-0.3745L9.5352,25.1927z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3848,28.389h-0.3496c-0.1328,0.8486-0.541,1.5518-1.2246,2.1094 c-0.6816,0.5576-1.623,0.8369-2.8203,0.8369c-2.0156,0-3.5625-0.7744-4.6445-2.3223c-1.083-1.5488-1.6235-3.7627-1.6235-6.6431 c0-1.5977,0.1621-2.9673,0.4868-4.1079c0.3247-1.1396,0.7866-2.0806,1.3857-2.8213c0.5996-0.7407,1.3193-1.2817,2.1592-1.6235 c0.8418-0.3408,1.7773-0.5117,2.8105-0.5117c1.5645,0,2.8457,0.3369,3.8457,1.0112c0.998,0.6743,1.7812,1.6445,2.3477,2.9092 l-2.5488,1.4731c-0.2832-0.832-0.7109-1.4893-1.2852-1.9727c-0.5742-0.4824-1.3613-0.7241-2.3594-0.7241 c-1.0996,0-1.9609,0.3584-2.584,1.0737c-0.625,0.7163-0.9375,1.7397-0.9375,3.0713v4.3462c0,1.332,0.3125,2.3555,0.9375,3.0713 c0.623,0.7158,1.4844,1.0732,2.584,1.0732c0.998,0,1.8301-0.2656,2.4961-0.7988c0.666-0.5322,1-1.2988,1-2.2969v-1.2744h-3.0469 v-2.647h6.0176v9.4146h-2.6465V28.389z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.3047,16.0949c-0.4489,0-0.8244-0.3516-0.8487-0.8052c-0.0704-1.3099-0.6158-2.5381-1.5356-3.4579 c-0.9215-0.9211-2.1513-1.4664-3.4632-1.5352c-0.4692-0.0243-0.8294-0.4247-0.8048-0.8939 c0.0243-0.4692,0.4154-0.8327,0.8939-0.8048c1.7323,0.0904,3.3579,0.8118,4.5771,2.031c1.2172,1.2172,1.9386,2.8398,2.0313,4.5698 c0.0253,0.4692-0.3346,0.87-0.8038,0.8949C37.3356,16.0945,37.32,16.0949,37.3047,16.0949z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.4442,15.4113c-0.439,0-0.8111-0.3373-0.847-0.7826c-0.1758-2.1898-1.1255-4.2501-2.6743-5.8006 c-1.5498-1.5495-3.6118-2.4989-5.8053-2.6733c-0.4682-0.0372-0.8178-0.4469-0.7806-0.9155 c0.0372-0.4682,0.4493-0.8155,0.9155-0.7806c2.5966,0.2064,5.0377,1.3312,6.8736,3.1668c1.8343,1.8363,2.9588,4.275,3.1671,6.867 c0.0375,0.4682-0.3117,0.8786-0.7799,0.9161C41.49,15.4103,41.4671,15.4113,41.4442,15.4113z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4G);
export default __webpack_public_path__ + "static/media/icon-4g.cfd7af78eca0ef56579f1a08e890fe59.svg";
export { ForwardRef as ReactComponent };